import React from 'react';
import { Flex, Text, Box, xcss } from '@atlaskit/primitives';

interface Props {
	children: React.ReactNode;
	isDisabled?: boolean;
	describedById: string;
	helpText: string;
}

export const DisabledButtonHelper: React.FC<Props> = ({
	children,
	isDisabled,
	describedById,
	helpText,
}) => {
	return (
		<Flex gap="space.050" alignItems="center">
			{isDisabled && (
				<Box xcss={helperTextWrapperStyles}>
					<Text as="p" size="small" color="color.text.subtle" id={describedById}>
						{helpText}
					</Text>
				</Box>
			)}
			{children}
		</Flex>
	);
};

const helperTextWrapperStyles = xcss({
	textAlign: 'right',
	width: '120px',
});
